<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  userListMethod,
  siteListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  page: {
    title: 'Add HOD/Teacher',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      userError: null,
      userDataStatus: false,
      isUserError: false,
      isLoading: false,
      editorData: '',
      image: '',
      show: false,
      departmentlist: [],
      platformId: '',
      platform: '',
      collegeId: '',
      collegeClass: null,
      classlist: [],
      department: null,
      options: [
        { value: 'hod', text: 'HOD' },
        { value: 'teacher', text: 'Teacher' },
      ],
      roleUser: 'hod',
      zoomUserId: null,
      zoomUserIdEmpty: false,
      zoomUserList: [],
    }
  },
  computed: {
    ...authComputed,
    ...departmentComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getDepartments()
    this.collegeId = this.profileData.college_id
    this.platformId = this.profileData.platform_id
    this.getZoomUser()
  },
  methods: {
    ...userListMethod,
    ...siteListMethod,
    ...departmentListMethod,
    getZoomUser() {
      this.getZoomUsers().then((res) => {
        var listitems = []
        listitems.push({ text: 'Select User', value: 'null', disabled: true })
        res.users.forEach((element) => {
          // if (
          //   this.platformId === 2 &&
          //   element.id === '-mOOLRHeQ7G765dWTmMymA'
          // ) {
          // } else {
          let ele = {}
          ele.text =
            element.first_name +
            ' ' +
            element.last_name +
            ' (' +
            element.id +
            ')'
          ele.value = element.id
          listitems.push(ele)
          //  }
        })
        this.zoomUserList = listitems
      })
    },
    addTeacherData() {
      if (this.roleUser === 'teacher') {
        if (this.collegeClass.includes('All')) {
          this.classlist.shift('All')
          this.collegeClass = []
          for (let i = 0; i < this.classlist.length; i++) {
            this.collegeClass[i] = this.classlist[i].value
          }
        }
      }
      if (this.zoomUserId === null) {
        this.zoomUserIdEmpty = true
      } else {
        this.zoomUserIdEmpty = false
      }
      if (!this.zoomUserIdEmpty) {
        this.isLoading = true
        const Data = {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          password: '12345678',
          phone: this.phone,
          status: 'active',
          platform_id: this.platformId,
          role: this.roleUser,
          platform: this.platform,
          college_id: this.collegeId,
          collegeClass: this.collegeClass,
          department: this.department,
          zoom_userId: this.zoomUserId,
        }
        this.addUser({ Data })
          .then((resp) => {
            this.isLoading = false
            this.$router.push({ name: 'teacher.list' })
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.userError = getError.message
            this.isUserError = true
            window.scrollTo(0, 0)
          })
      }
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.firstName.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.lastName.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars2(event) {
      if (event.charCode === 32 && !this.email.length) {
        event.preventDefault()
      } else {
        if (event.charCode !== 32) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    getClasses() {
      this.collegeClass = null
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            if (this.department === element.department) {
              ele.text = element.name
              ele.value = element._id
              ele.college = element.college_id
              listitems.push(ele)
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.department = null
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          listitems.push({
            value: null,
            text: 'Select Department',
            disabled: true,
          })
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            * Mandatory Fields<br /><br />
            <b-alert
              v-model="isUserError"
              variant="danger"
              v-html="userError"
            ></b-alert>
            <b-form
              data-parsley-validate
              novalidate
              @submit.prevent="addTeacherData"
            >
              <b-form-group label="First Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="firstName"
                  type="text"
                  placeholder="Enter First Name"
                  @keypress="restrictChars($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Last Name*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="lastName"
                  type="text"
                  placeholder="Enter Last Name"
                  @keypress="restrictChars1($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Email Id*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="Enter Email"
                  @keypress="restrictChars2($event)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Phone Number*" label-for="input-1">
                <b-form-input
                  id="input-1"
                  v-model="phone"
                  type="number"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                  maxlength="12"
                  placeholder="Enter Phone Number(with country code)"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Role*" label-for="input-2">
                <b-form-select
                  v-model="roleUser"
                  :options="options"
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Select Department*" label-for="input-1">
                <b-form-select
                  v-model="department"
                  :options="departmentlist"
                  @change="getClasses"
                ></b-form-select>
              </b-form-group>
              <b-form-group
                v-if="roleUser !== 'hod'"
                label="Select Class*"
                label-for="input-1"
              >
                <b-form-select
                  v-model="collegeClass"
                  :options="classlist"
                  multiple
                ></b-form-select>
              </b-form-group>
              <b-form-group label="Select Zoom User Id*" label-for="input-1">
                <b-form-select
                  v-model="zoomUserId"
                  :options="zoomUserList"
                ></b-form-select>
              </b-form-group>

              <p v-if="zoomUserIdEmpty" style="color: red"
                >Please add Zoom user Id</p
              >
              <b-form-group id="button-group" class="mt-4">
                <b-button
                  v-if="!isLoading"
                  type="submit"
                  variant="primary"
                  style="color: white"
                  >Save</b-button
                >
                <b-button
                  v-else
                  type="submit"
                  variant="primary"
                  class="btn-block"
                  disabled
                >
                  <b-spinner small></b-spinner>Loading...
                </b-button>
              </b-form-group>
              <a class="cancel-anchor" href="/teacher-list"
                ><b-button
                  v-if="!isLoading"
                  class="cancel"
                  type="button"
                  variant="primary"
                  >Cancel</b-button
                ></a
              >
            </b-form>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}

.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
